import styled from 'styled-components';
import { Image } from '../../../../../../raw-components/image/image';

//info-image default
export const ArenaPictureDefaultBox = styled(Image)`
    display: block;
    min-height: 20rem;

    width: 372px;
    height: 200px;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
      width: 282px;
      height: 175px;
   }
`;

